export default __webpack_public_path__ + "static/media/Pick.5a621601.svg";